import { useCallback, useRef } from "react";
import useCancelRequests from "./useCancelRequests";

const useSingleRequest = (componentName?: string) => {
  const {
    getToken,
    cancelRequest,
    isCanceled,
    disposeToken,
  } = useCancelRequests(componentName);

  const lastCancelTokenRef = useRef<string>();

  const getCancelToken = useCallback(() => {
    if (lastCancelTokenRef.current) {
      cancelRequest(lastCancelTokenRef.current);
    }
    const token = getToken();
    lastCancelTokenRef.current = token.id;
    return token;
  }, [cancelRequest, getToken]);

  return { isCanceled, getCancelToken, disposeToken };
};
export default useSingleRequest;
